import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { UpdateEntityDetailsClientRequest } from '../@types/UpdateEntityDetails'

type Store = {
  updateEntityDetails: UpdateEntityDetailsClientRequest | null
  setUpdateEntityDetails: (value: UpdateEntityDetailsClientRequest) => void
}

export const useUpdateEntityDetailsStore = create<Store>()(
  devtools(
    (set) => ({
      updateEntityDetails: null,
      setUpdateEntityDetails: (updateEntityDetails) =>
        set({ updateEntityDetails }),
    }),
    { name: 'UpdateEntityDetailsStore' },
  ),
)
